<template>
  <LMap
    :zoom="map.zoom"
    :center="lngLat"
    :options="map.options"
    ref="leaflet"
    @ready="addBasemapLayer()"
  >
    <LMarker :lat-lng="lngLat">
      <MarkerPin />
    </LMarker>
  </LMap>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
import MarkerPin from "../../common/map/MarkerPin.vue";

export default {
  name: "ObservationViewLocation",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    MarkerPin,
  },
  props: {
    lngLat: {
      type: Object,
      required: true,
      validator: (obj) =>
        obj.hasOwnProperty("lat") &&
        obj.hasOwnProperty("lng") &&
        typeof obj.lat === "number" &&
        typeof obj.lng === "number",
    },
  },
  data() {
    return {
      // used by the map
      map: {
        zoom: 12,
        options: {
          zoomControl: false,
        },
      },
      activeLayer: null,
    };
  },
  computed: {
    ...mapGetters({
      BASEMAP_FACTORY: "map/BASEMAP_FACTORY",
    }),
  },
  mounted() {
    // Map is re-invalidated after mounted hook
    setTimeout(() => {
      const map = this.$refs.leaflet && this.$refs.leaflet.mapObject;
      if (map) {
        map.invalidateSize();
      }
    }, 350);
  },
  methods: {
    addBasemapLayer() {
      const map = this.$refs.leaflet && this.$refs.leaflet.mapObject;
      if (!map || !this.BASEMAP_FACTORY) return;
      // Remove the previous layer used by this instance before adding a new one
      if (this.activeLayer) {
        try {
          map.removeLayer(this.activeLayer);
        } catch (e) {
        }
      }
      this.activeLayer = this.BASEMAP_FACTORY();
      this.activeLayer.addTo(map);
      map.invalidateSize();
    },
  },
  watch: {
    BASEMAP_FACTORY() {
      this.addBasemapLayer();
    },
  },
};
</script>

<style scoped>
/* Optional: style the map container */
</style>
